import ReconnectingWebSocket from "reconnecting-websocket";

export default class ASRManager {
  constructor({ url, onOpen, onResult, onClose, onError }) {
    this.url = url;
    this.ws = null;
    this.onOpen = typeof onOpen === "function" ? onOpen : () => {};
    this.onResult = typeof onResult === "function" ? onResult : () => {};
    this.onClose = typeof onClose === "function" ? onClose : () => {};
    this.onError = typeof onError === "function" ? onError : () => {};

    // ✅ 保存监听函数引用
    this.handleOpen = this.handleOpen.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
  }

  connect() {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      return;
    }
    this.ws = new ReconnectingWebSocket(this.url);
    this.ws.addEventListener("open", this.handleOpen);
    this.ws.addEventListener("message", this.handleMessage);
    this.ws.addEventListener("close", this.onClose);
    this.ws.addEventListener("error", this.onError);
  }
  handleOpen() {
    this.ws?.send(
      JSON.stringify({
        audio: {
          audioType: "wav",
          sampleRate: 16000,
          channel: 1,
          sampleBytes: 2,
        },
      }),
    );
    this.onOpen && this.onOpen();
  }

  handleMessage({ data }) {
    try {
      const res = JSON.parse(data);
      this.onResult && this.onResult(res);
    } catch (e) {
      console.log("ASR parse error:", e);
    }
  }

  send(data) {
    this.ws?.send(data);
  }

  /**
   * ✅ 移除监听事件
   */
  removeListeners() {
    if (!this.ws) return;
    this.ws.removeEventListener("open", this.handleOpen);
    this.ws.removeEventListener("message", this.handleMessage);
    this.ws.removeEventListener("close", this.onClose);
    this.ws.removeEventListener("error", this.onError);
  }

  /**
   * ✅ 安全关闭
   */
  close() {
    if (!this.ws) return;
    this.removeListeners(); // ✅ 先移除监听
    this.ws.close();
    this.ws = null;
  }
}
